import { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Skeleton, Chip, Avatar, Box } from "@mui/material";
import { report } from "../../features/reports/reportsSlice";
import { TitleWSelect, InfoTotal } from "../Tools";
import { getYears } from "../Tools/functions";

const initialState = { total: 0, events: [] };

const Reports = () => {
    const { isLoading } = useSelector(state => state.progress);
    const [data, setData] = useState(initialState);
    const [status, setStatus] = useState('idle');
    const [year, setYear] = useState('');
    const options = useMemo(() => getYears(), [])
    const dispatch = useDispatch();
    const headers = ['Área', 'Evento', 'Tipo', 'Temática', 'Ods']
    
    const handleChange = (e) => {
        setYear(e.target.value)
        if(e.target.value !== ''){
            report(`one/year/${e.target.value}`, dispatch, setData, setStatus)
        }else{
            setStatus('idle')
            setData([]);
        }
    }
    const info = [{ id: 'H', name: 'Hombre' }, { id: 'M', name: 'Mujer' }, { id: 'I', name: 'Indigena' }, { id: 'T', name: 'Total' }]
    return(
        <Container component={Paper} sx={{ p: '2em', mb: '2em' }} maxWidth='xl'>
            <TitleWSelect title={'REPORTE DE ASISTENCIA POR SEXO'} handleChange={handleChange} options={options} year={year} />
            { status === 'succeeded' && <InfoTotal num={data.total} /> }
            { isLoading ? <Skeleton animation='wave' height={200} /> : (data.total ? (
                <TableContainer>
                    <Box display={'flex'} sx={{ justifyContent: 'space-between', mb: '1em', mt: '1em' }}>
                        { info.map(({ id, name }, i) => <Chip key={i} avatar={<Avatar>{id}</Avatar>} label={name} color="primary" variant="outlined" />) }
                    </Box>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell colSpan={5}></TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }} colSpan={4}>ALUMNOS</TableCell>
                                    <TableCell align="center" sx={{ bgcolor: 'lightgray', color: 'black', fontSize: '0.7em' }} colSpan={4}>EGRESADOS</TableCell>
                                    <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }} colSpan={3}>PROFESORES</TableCell>
                                    <TableCell align="center" sx={{ bgcolor: 'lightgray', color: 'black', fontSize: '0.7em' }} colSpan={3}>ADMINISTRATIVOS</TableCell>
                                    <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }} colSpan={3}>EXTERNOS</TableCell>
                                    <TableCell align="center" sx={{ bgcolor: 'lightgray', color: 'black', fontSize: '0.7em' }}>TOTAL</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableHead>
                            <TableRow>
                                { headers.map((h, i) => <TableCell key={i} sx={{ fontSize: '0.7em' }}>{h}</TableCell>) }
                                <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }}>H</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }}>M</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }}>I</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }}>T</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'lightgray', color: 'black', fontSize: '0.7em' }}>H</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'lightgray', color: 'black', fontSize: '0.7em' }}>M</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'lightgray', color: 'black', fontSize: '0.7em' }}>I</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'lightgray', color: 'black', fontSize: '0.7em' }}>T</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }}>H</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }}>M</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }}>T</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'lightgray', color: 'black', fontSize: '0.7em' }}>H</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'lightgray', color: 'black', fontSize: '0.7em' }}>M</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'lightgray', color: 'black', fontSize: '0.7em' }}>T</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }}>H</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }}>M</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'gray', color: 'white', fontSize: '0.7em' }}>T</TableCell>
                                <TableCell align="center" sx={{ bgcolor: 'lightgray' }}></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            { data.events.map(({ area, evento, tipo, tematica, ods, alumnos, egresados, profesores, administrativos, externos, total }, i) => (
                                <TableRow key={i} sx={{ fontSize: '0.7em' }}>
                                    <TableCell>{area}</TableCell>
                                    <TableCell>{evento}</TableCell>
                                    <TableCell>{tipo}</TableCell>
                                    <TableCell>{tematica}</TableCell>
                                    <TableCell>{ods}</TableCell>
                                    <TableCell align="center">{alumnos.hombres}</TableCell>
                                    <TableCell align="center">{alumnos.mujeres}</TableCell>
                                    <TableCell align="center">{alumnos.indigenas}</TableCell>
                                    <TableCell align="center"><b>{alumnos.total}</b></TableCell>
                                    <TableCell align="center">{egresados.hombres}</TableCell>
                                    <TableCell align="center">{egresados.mujeres}</TableCell>
                                    <TableCell align="center">{egresados.indigenas}</TableCell>
                                    <TableCell align="center"><b>{egresados.total}</b></TableCell>
                                    <TableCell align="center">{profesores.hombres}</TableCell>
                                    <TableCell align="center">{profesores.mujeres}</TableCell>
                                    <TableCell align="center"><b>{profesores.total}</b></TableCell>
                                    <TableCell align="center">{administrativos.hombres}</TableCell>
                                    <TableCell align="center">{administrativos.mujeres}</TableCell>
                                    <TableCell align="center"><b>{administrativos.total}</b></TableCell>
                                    <TableCell align="center">{externos.hombres}</TableCell>
                                    <TableCell align="center">{externos.mujeres}</TableCell>
                                    <TableCell align="center"><b>{externos.total}</b></TableCell>
                                    <TableCell align="center"><b>{total}</b></TableCell>
                                </TableRow>
                            )) }
                        </TableBody>
                    </Table>
                </TableContainer>
                ) : null
            )}
        </Container>
    )
}

export default Reports;